import _ from 'lodash';

if($('#resource-search').length) {

    let searchContainer = $('#resource-search'),
        searchForm = $('#resource-search-form'),
        searchInput = $('#resource-search-input'),
        resultsContainer = $('#resource-search-results'),
        paginationContainer = $('#resource-pagination-container'),
        paginationDisplay = $('.resource-pagination-display'),
        previousSearch = '',
        initialSearchComplete = false,
        // letterFilter = '',
        // letterClearButton = $('.mayo-clear-letter'),
        // letterFilterButtons = $('.mayo-filter-letter button'),
        topicFilterItems = $('.resource-filter-topic'),
        currentFilterTags = $('.resource-current-filter-tags'),
        clearFilterButton = $('.tags-filter-reset .clear'),
        page = 1;

    searchInput.on('keyup update', function() {
        if(previousSearch.length > 0 && searchInput.val().length === 0) {
            page = 1;
            resourceSearch();
        }
        previousSearch = searchInput.val();
    });

    searchInput.on('search', function() {
        if(searchInput.val().length === 0) {
            page = 1;
            resourceSearch();
        }
        previousSearch = searchInput.val();
    });

    searchInput.on('keyup update', _.debounce(function () {

        if(searchInput.val().length > 2) {
            resourceSearch();
        }

    }, 500));

    searchForm.on('submit', function(e) {
        e.preventDefault();

        resourceSearch();
    });

    $(document).on('click', '.resource-page-link', function (e) {
        e.preventDefault();
        page = $(this).data('page');
        resourceSearch();
    });

    $(document).on('click', '.resource-page-prev', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;
        page--;
        resourceSearch();
    });

    $(document).on('click', '.resource-page-next', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;
        page++;
        resourceSearch();
    });

    // letterFilterButtons.on('click', function() {
    //     if($(this).hasClass('service-clear-letter')) return;
    //
    //     if($(this).hasClass('is-checked')) {
    //         $(this).removeClass('is-checked');
    //         letterFilter = '';
    //         resourceSearch();
    //         return;
    //     }
    //
    //     letterFilterButtons.removeClass('is-checked');
    //     $(this).addClass('is-checked');
    //     letterClearButton.addClass('active');
    //     letterFilter = $(this).data('letter');
    //     resourceSearch();
    // });
    //
    // letterClearButton.on('click', function() {
    //     letterFilterButtons.removeClass('is-checked');
    //     $(this).removeClass('active');
    //     letterFilter = '';
    //     resourceSearch();
    // });

    $(document).on('click', '.resource-filter-topic', function(e) {
        e.preventDefault();
        // console.log('clicked');
        $(this).closest('li').toggleClass('is-checked');
        e.stopPropagation();
        resourceSearch();
    });
    // topicFilterItems.on('click', function(e) {
    //     e.preventDefault();
    //     $(this).parent().toggleClass('is-checked');
    //     if ($('.is-checked').length > 0) {
    //         $('.js-resources-clear').removeClass('d-none');
    //     } else {
    //         $('.js-resources-clear').addClass('d-none');
    //     }
    //     resourceSearch();
    // });

    $(document).on('click', '.resource-current-filter-tags button', function () {
        $('.resource-filter-topic-' + $(this).data('topic')).parent().removeClass('is-checked');
        resourceSearch();
    });

    clearFilterButton.on('click', function() {
        topicFilterItems.parent().removeClass('is-checked');
        page = 1;
        resourceSearch();
    });

    function showHideClearButton() {

        if(topicFilterItems.parent().hasClass('is-checked')) {
            clearFilterButton.removeClass('d-none');
        } else {
            clearFilterButton.addClass('d-none');
        }

    }


    function resourceSearch() {

        $('#resource-container').addClass('loading');

        let topicFilters = [];

        topicFilterItems.each(function() {
            if($(this).parent().hasClass('is-checked')) {
                topicFilters.push($(this).data('topic'));
            }
        });

        // console.log('topicFilters', topicFilters);
        // console.log('search',searchInput.val());

        showHideClearButton();

        $.post("/wp-admin/admin-ajax.php", {
            'action': 'resource_search',
            'topics': topicFilters,
            'query': searchInput.val(),
            // 'letter': letterFilter,

            'page': page,
        }, function (response) {

            resultsContainer.html(response.data.results);
            paginationContainer.html(response.data.pagination);
            paginationDisplay.html(response.data.pagination_display);
            currentFilterTags.html(response.data.current_filter_tags);

            $('html, body').animate({
                scrollTop: $('#resource-search').offset().top
            }, 500);

            $('#resource-search').removeClass('loading');

        });

    }

}